import React from "react";
import ProductDetails from "../../components/ProductDetails";
import { useParams } from "react-router-dom";
import { queryKeys } from "../../services/react-query/queryKeys";
import { productDetails } from "../../network/product";
import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import CartLoading from "../../components/PlaceHolder/CartLoading";

const ProductDetailsPage = () => {
  const { i18n } = useTranslation();
  const { code } = useParams();

  const { data: productData, isLoading } = useQuery({
    queryKey: [queryKeys.listProducts, code, i18n],
    queryFn: () => productDetails(code),
    enabled: !!code,
  });

  if (isLoading) {
    return <CartLoading isLoading={isLoading} />;
  }

  return (
    <ProductDetails data={productData?.data} />
  );
};

export default ProductDetailsPage;